import {EditDiscountCodeFormValuesV2} from "../types";
import type {OfferingOption} from "../../../../react-query-hooks/offerings";

export type V2UpdateDiscountCodePayload = {
  code: string;
  offerings: {
    bookings: number[];
    liveClasses: number[];
    products: number[];
    productServices: number[];
    subscriptions: number[];
  };
  percentageOff: number;
  usageLimit: number;
  isMultipleUse: boolean;
  isAllOfferings: boolean;
  startDate: string;
  endDate: string;
  disableDiscount: boolean;
};

export function buildV2UpdatePayload(
  values: EditDiscountCodeFormValuesV2 & {id: number},
  allOfferings: OfferingOption[]
): V2UpdateDiscountCodePayload {
  const offeringsMap = new Map(allOfferings.map((o) => [o.value, o]));

  const bookings: number[] = [];
  const liveClasses: number[] = [];
  const products: number[] = [];
  const productServices: number[] = [];
  const subscriptions: number[] = [];

  values.offerings.forEach((offeringValue) => {
    const offering = offeringsMap.get(offeringValue);
    if (!offering) return;

    switch (offering.category) {
      case "services":
        bookings.push(offering.offeringId);
        break;
      case "liveEvents":
        liveClasses.push(offering.offeringId);
        break;
      case "digitalProducts":
        products.push(offering.offeringId);
        break;
      case "productServices":
        productServices.push(offering.offeringId);
        break;
      case "subscriptions":
        subscriptions.push(offering.offeringId);
        break;
    }
  });

  return {
    code: values.name,
    offerings: {
      bookings,
      liveClasses,
      products,
      productServices,
      subscriptions,
    },
    percentageOff: values.percentage_off,
    usageLimit: values.usage_limit,
    isMultipleUse: values.usage === "multiple",
    isAllOfferings: values.selectAllOfferings ?? false,
    startDate: values.validity[0],
    endDate: values.validity[1],
    disableDiscount: values.disable_discount === "enabled" ? false : true,
  };
}
